<template>
    <div class="wrapper" style="background: #1E131F">
        <parallax class="page-header header-filter" :style="headerStyle">
            <div class="md-layout">
                <div class="md-layout-item">
                    <div class="image-wrapper">
                        <div class="brand">
                            <h1>Alba</h1>
                            <h3>Asociación para la ayuda a personas con albinismo.</h3>
                        </div>
                    </div>
                </div>
            </div>
        </parallax>

        <div class="main main-raised">
            <div class="section">
                <div class="container" style="column-count:2">
                    <div class="md-layout">
                        <div class=" md-size-66 md-xsmall-size-100 mx-auto text-center">
                            <img :src="bemyvega" alt="Logo Bemyvega" />
                            <!-- <h2 class="title text-center">Bemyvega</h2> -->
                            <h3>"La tecnología es la herramienta que nos posibilita el acceso a una formación sin límites, eliminando las barreras que no nos permiten avanzar"</h3>
                        </div>
                    </div>

                    <div class="features text-center" id="downloadSection1">
                        <div class="md-layout">
                            <div class="md-layout-item md-medium-size-33 md-small-size-100">
                                <div class="info">
                                    <div class="icon icon-info"><md-icon style="color:#007680!important;height:5.2rem;">settings</md-icon><md-icon style="color:#007680!important;">palette</md-icon></div>
                                    <h4 class="info-title">Herramientas de accesibilidad</h4>

                                    <p style="color:black;  font-size:1.2rem;">
                                        Acondicionamos nuestros entornos para ofrecer herramientas como filtros, cambios de contraste, de escala... para facilitar la vida de las personas con baja visión.
                                    </p>
                                </div>
                            </div>
                            <div class="md-layout-item md-medium-size-33 md-small-size-100">
                                <div class="info">
                                    <div class="icon icon-danger">
                                        <!-- <md-icon>fingerprint</md-icon> -->
                                        <a target="_blank" href="https://apps.apple.com/es/app/vega-player/id1560650182"> <img :src="apple" alt="Enlace bemyvega AppStore"/></a>
                                        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.vega.VEGAPLAYER"> <img :src="google" alt="Enlace bemyvega Google Play"/></a>
                                    </div>
                                    <h4 class="info-title">Aplicaciones móviles</h4>
                                    <p style="color:black;  font-size:1.2rem;">
                                        Disponemos de aplicaciones propias para que puedas conectar cualquier dispositivo, ya sea tablet o móvil, al equipo que hace la retransmisión.
                                    </p>
                                </div>
                            </div>
                            <div class="md-layout-item md-medium-size-33 md-small-size-100">
                                <div class="info">
                                    <div class="icon icon-success">
                                        <!-- <md-icon>verified_user</md-icon> -->
                                        <a target="_blank" href="https://www.microsoft.com/es-es/microsoft-teams/log-in"><img :src="teams" alt="Enlace teams" /> </a>
                                        <a target="_blank" href="https://zoom.us/"><img :src="zoom" alt="Enlace zoom" /> </a>
                                        <a target="_blank" href="https://meet.google.com/"><img :src="meet" alt="Enlace google meets" /> </a>
                                    </div>
                                    <h4 class="info-title">Plataformas de colaboración</h4>
                                    <p style="color:black; font-size:1.2rem;">
                                        Además podrás crear reuniones en cualquiera de las plataformas de videoconferencia más habituales del mercado.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <md-button href="https://bemyvega.com/contact/" target="_blank" class="md-success md-lg text-center" style="width:40%; margin:auto;">Contacto</md-button>
                </div>
            </div>
            <div class="section text-center"></div>
        </div>

        <div class="main main-raised" style="margin-bottom:3rem;">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center">
                <br />
                <h2 class="title text-center">Noticias destacadas</h2>
            </div>
            <div class="section md-layout col-12 section-download mx-auto">
                <div class="container text-center">
                    <div class="md-layout layout-main" style="margin-right:2rem; margin-left:2rem;">
                        <div class="md-layout-item md-medium-size-33 md-small-size-100">
                            <img :src="noticia1" alt="Noticia: Fondo solidario alba" class="img-raised rounded img-fluid text-center " /><br />

                            <md-button href="https://albinismo.es/news/fondo-solidario-alba/" target="_blank" class="md-simple md-success md-lg text-center">FONDO SOLIDARIO ALBA </md-button>
                        </div>
                        <div class="md-layout-item md-medium-size-33 md-small-size-100">
                            <img :src="noticia2" alt="Noticia: Proyecto europeo summer camp" class="img-raised rounded img-fluid text-center" /><br />

                            <md-button href="https://albinismo.es/news/proyecto-europeo-summer-camp/" target="_blank" class="md-simple md-success md-lg text-center ">PROYECTO EUROPEO SUMMER CAMP </md-button>
                        </div>
                        <div class="md-layout-item md-medium-size-33 md-small-size-100">
                            <img :src="noticia3" alt="Noticia: plan estratégico para afrontar los retos del futuro" class="img-raised rounded img-fluid text-center" /><br />
                            <md-button href="https://albinismo.es/news/un-plan-estrategico-para-afrontar-los-retos-del-futuro/" target="_blank" class="md-simple md-success md-lg text-center "
                                >UN PLAN ESTRATÉGICO PARA <br />
                                aFRONTAR LOS RETOS DEL FUTURO
                            </md-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main main-raised  ">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center" id="downloadSection">
                <br />
                <h2 class="title text-center">Albinism Europe</h2>
            </div>
            <div class="section md-layout col-12">
                <div class="md-layout-item col-3 m-3">
                    <a href="https://albinismo.es/" target="_blank">
                        <img src="../assets/img/logos/alba1.png" alt="Logo alba" />
                    </a>
                </div>
                <div class="md-layout-item col-3">
                    <a href="https://www.albinisme.dk/" target="_blank">
                        <img src="../assets/img/logos/dffa.png" alt="Logo dffa" />
                    </a>
                </div>
                <div class="md-layout-item col-3">
                    <a href="https://albinit.org/" target="_blank">
                        <img src="../assets/img/logos/Albinit.png" alt="Logo albinit" />
                    </a>
                </div>
                <div class="md-layout-item col-3">
                    <a href="https://www.albinisme.no/" target="_blank">
                        <img src="../assets/img/logos/NFFA.png" alt="Logo nffa" />
                    </a>
                </div>
                <div class="md-layout-item col-3">
                    <a href="http://albinismiyhdistys.omasivu.fi/en/" target="_blank">
                        <img src="../assets/img/logos/suomen.jpg" alt="Logo Suomen" />
                    </a>
                </div>
            </div>
            <div class="md-layout col-12">
                <div class="md-layout-item col-3">
                    <a href="https://www.genespoir.org/page/1518766-accueil" target="_blank">
                        <img src="../assets/img/logos/genespoir.jpg" alt="Logo Genespoir" />
                    </a>
                </div>
                <div class="md-layout-item col-3">
                    <a href="https://www.albinismus.de/" target="_blank">
                        <img src="../assets/img/logos/noah.png" alt="Logo noah" />
                    </a>
                </div>
                <div class="md-layout-item col-3">
                    <a href="https://www.albinizm.org.tr/" target="_blank">
                        <img src="../assets/img/logos/logo_abinizm.jpg" alt="logo albinizm Dernegi " />
                    </a>
                </div>
                <div class="md-layout-item col-3">
                    <a href="https://www.oogvereniging.nl/ledengroep/patientengroep-albinisme/" target="_blank">
                        <img src="../assets/img/logos/oogvereniging-logo.png" alt="Logo oogvereniging" />
                    </a>
                </div>

                <div class="md-layout-item col-3">
                    <a href="https://www.albinism.org.uk/" target="_blank">
                        <img src="../assets/img/logos/AF_logo.png" alt="Logo albinism fellowship" />
                    </a>
                </div>
            </div>
            <div class="section">
                <!-- style="background-image:url(http://albinismo.es/wp-content/uploads/ALBA_contadores.jpg);" -->
                <div class="container">
                    <div class="md-layout">
                        <div class="md-layout-item text-center">
                            <h4 class="title " style="color:black;">No solo es cuestión de color</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    bodyClass: "index-page",
    props: {
        image: {
            type: String,
            default: require("@/assets/img/fondo2.png")
        },
        landing: {
            type: String,
            default: require("@/assets/img/noticia3.png")
        },
        profile: {
            type: String,
            default: require("@/assets/img/noticia1.jpg")
        },
        noticia3: {
            type: String,
            default: require("@/assets/img/noticia1.png")
        },
        noticia2: {
            type: String,
            default: require("@/assets/img/noticia1.jpg")
        },
        noticia1: {
            type: String,
            default: require("@/assets/img/noticia3.png")
        },
        noticia4: {
            type: String,
            default: require("@/assets/img/noticia4.png")
        },
        google: {
            type: String,
            default: require("@/assets/img/googleplay-150x150.png")
        },
        apple: {
            type: String,
            default: require("@/assets/img/applestore-150x150.png")
        },
        teams: {
            type: String,
            default: require("@/assets/img/teams.png")
        },
        zoom: {
            type: String,
            default: require("@/assets/img/zoom.png")
        },
        meet: {
            type: String,
            default: require("@/assets/img/meet.png")
        },
        bemyvega: {
            type: String,
            default: require("@/assets/img/logo-bemyvega.png")
        }
    },
    data() {
        return {
            firstname: null,
            email: null,
            password: null,
            leafShow: false
        };
    },
    methods: {
        leafActive() {
            if (window.innerWidth < 768) {
                this.leafShow = false;
            } else {
                this.leafShow = true;
            }
        }
    },
    computed: {
        headerStyle() {
            return {
                backgroundImage: `url(${this.image})`
            };
        },
        signupImage() {
            return {
                backgroundImage: `url(${this.signup})`
            };
        }
    },
    mounted() {
        this.leafActive();
        window.addEventListener("resize", this.leafActive);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.leafActive);
    }
};
</script>
<style lang="scss">
.section-download {
    .md-button + .md-button {
        margin-left: 5px;
    }
}

@media all and (min-width: 991px) {
    .btn-container {
        display: flex;
    }
}
</style>
